<script>
  import { emitter } from '@/main.js';
  import { debounce, handleViewportSize } from '@/lib/vue-helpers.js';
  import PDPaddToCartButton from '@/components/PDPaddToCartButton.vue';
  export default {
    name: 'PDPaddToCartSticky',
    components: {
      PDPaddToCartButton
    },
    data() {
      return {
        addToCartText: '',
        UnavailableText: '',
        SoldOutText: '',
        variantId: '',
        parentId: '',
        variantPrice: '',
        handle: '',
        instock: false,
        countryCode: '',
        currencyCode: '',
        loading: false,
        notavail: false,
        hideButton: false,
        showWidget: false,
        stickyVisible: false,
        success: false,
        showingForm: true,
        error: false,
        compare: '',
        variantPriceNumber: '',
        formEmail: '',
        formEmailList: '',
        formEmailListId: '',
        emailFormValidationError: false,
        comingsoon_tag: '',
        comingsoonText: '',
        comingSoonProduct: false,
        klaviyoEnabled: false,
        joinMessage: '',
        NotifyMeSuccess: '',
        NotifyMeText: '',
        enable_klaviyo: false,
        klaviyo_key: '',
        klaviyoFormShowing: false,
        gwpEnabled: window.siteGlobals.gwpEnabled,
        gwpTag: window.siteGlobals.gwpTag,
        gwpProduct1: window.siteGlobals.gwpProduct1,
        gwpProduct2: window.siteGlobals.gwpProduct2,
        gwpProduct3: window.siteGlobals.gwpProduct3,
        gwpProduct4: window.siteGlobals.gwpProduct4,
        gwpProduct5: window.siteGlobals.gwpProduct5,
        membershipPrice: '',
        useMemberPrice: false,
        stickyAtcInitialized: false,
        zoomOpen: false
      };
    },
    mounted() {
      var self = this;
      const dataEl = this.$el?.parentElement;
      this.handleViewportSize = handleViewportSize(this, { useRoot: true });
      this.countryCode = window.Shopify.country;
      this.currencyCode = window.Shopify.currency.active;
      this.addToCartText = dataEl.getAttribute('data-addToCartText');
      this.UnavailableText = dataEl.getAttribute('data-UnavailableText');
      this.SoldOutText = dataEl.getAttribute('data-SoldOutText');
      this.NotifyMeText = dataEl.getAttribute('data-NotifyMeText');
      this.NotifyMeSuccess = dataEl.getAttribute('data-NotifyMeSuccess');
      this.joinMessage = dataEl.getAttribute('data-joinMessage');
      this.comingsoon_tag = dataEl.getAttribute('data-comingsoon_tag');
      this.comingsoonText = dataEl.getAttribute('data-comingsoonText');
      this.enable_klaviyo = dataEl.getAttribute('data-enable_klaviyo');
      this.klaviyo_key = dataEl.getAttribute('data-klaviyo-company-key');
      this.formEmailListId = dataEl.dataset.klaviyoListId;

      this.useMemberPrice = dataEl.getAttribute('data-use-member-price') === 'true';

      if (this.enable_klaviyo != 'false') {
        this.checkIfKlaviyoLoaded();
      }

      this.selectedColor = '';
      this.selectedSize = '';
      this.selectedBling = '';

      emitter.on('updateAddButton', e => {
        self.variantId = e.variantId;
        self.parentId = e.parentId;
        self.handle = e.handle;
        self.variantPrice = this.convertToCurrency(e.variantPrice);
        self.instock = e.instock;
        self.notavail = e.notavail;
        self.showWidget = true;
        self.success = false;
        self.showingForm = true;
        self.loading = false;
        self.error = false;
        (self.compare = e.comparePrice), (self.variantPriceNumber = e.variantPrice);
        this.checkShouldFormShow();
      });

      this.handleMembershipPriceUpdate = e => {
        const { formattedMembershipPrice, shouldShowMemberPrice } = e.detail;

        if (shouldShowMemberPrice) {
          self.membershipPrice = formattedMembershipPrice;
        } else {
          self.membershipPrice = '';
        }
      };
      window.addEventListener('membershipPriceUpdated', this.handleMembershipPriceUpdate);

      emitter.on('pdp-tags-updated', e => {
        const tags = e.tags;
        this.comingSoonProduct = false;
        this.checkComingSoonState(tags);
      });

      const rawTags = dataEl.getAttribute('data-product-tags');
      if (rawTags) {
        try {
          const tags = JSON.parse(rawTags);
          this.checkComingSoonState(tags);
        } catch (_) {
          void _;
        }
      }

      emitter.on('updateEmailError', e => {
        self.emailFormValidationError = e.emailFormValidationError;
      });

      emitter.on('updateSuccessState', e => {
        self.success = e.success;
      });

      emitter.on('updateUpsellVariantId', e => {
        self.variantId = e.upsellVariantId;
        self.variantPrice = this.convertToCurrency(e.upsellVariantPrice);
      });

      this.$nextTick(() => {
        this.initializeStickyATC();
      });

      this.onStickyResize = () => this.initializeStickyATC();
      document.addEventListener('theme:resize:width', this.onStickyResize);

      this.onZoomOpen = () => {
        this.zoomOpen = true;
      };
      this.onZoomClose = () => {
        this.zoomOpen = false;
        this.toggleVisibility();
      };
      document.addEventListener('pdp-zoom:open', this.onZoomOpen);
      document.addEventListener('pdp-zoom:close', this.onZoomClose);

      this.onCookieBarChange = () => {
        this.updateStickyButtonPosition();
        this.syncFloatingWidgetLift();
      };
      document.addEventListener('cookie-bar:change', this.onCookieBarChange);
      document.addEventListener('chat:hide', this.onCookieBarChange);
      document.addEventListener('chat:show', this.onCookieBarChange);

      setTimeout(debounce(this.toggleVisibility), 100);
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    unmounted() {
      if (this.handleViewportSize) this.handleViewportSize();
      if (this.onStickyResize) document.removeEventListener('theme:resize:width', this.onStickyResize);
      if (this.onZoomOpen) document.removeEventListener('pdp-zoom:open', this.onZoomOpen);
      if (this.onZoomClose) document.removeEventListener('pdp-zoom:close', this.onZoomClose);
      if (this.cookieLiftTimer) clearTimeout(this.cookieLiftTimer);
      if (this.onCookieBarChange) {
        document.removeEventListener('cookie-bar:change', this.onCookieBarChange);
        document.removeEventListener('chat:hide', this.onCookieBarChange);
        document.removeEventListener('chat:show', this.onCookieBarChange);
      }
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('membershipPriceUpdated', this.handleMembershipPriceUpdate);
      this.clearStickyAtcState();
    },
    methods: {
      isStickyAtcViewport() {
        return window.innerWidth <= window.theme?.sizes?.medium;
      },
      clearStickyAtcState() {
        document.querySelector('.template-product')?.classList.remove('sticky-atc-container-visible');
        document.documentElement.classList.remove('sticky-atc-container-visible');
        document.documentElement.style.removeProperty('--sticky-atc-shift');
        this.stickyVisible = false;
      },
      updateFloatingWidgetLift(stickyContainer) {
        const stickyTop = stickyContainer.getBoundingClientRect().top;
        const offset = parseFloat(getComputedStyle(stickyContainer).getPropertyValue('--sticky-atc-offset')) || 0;
        const shift = Math.round(Math.max(0, window.innerHeight - stickyTop - offset));
        document.documentElement.style.setProperty('--sticky-atc-shift', `${shift}px`);
      },
      syncFloatingWidgetLift() {
        this.toggleVisibility();
        requestAnimationFrame(() => this.toggleVisibility());
        if (this.cookieLiftTimer) clearTimeout(this.cookieLiftTimer);
        this.cookieLiftTimer = setTimeout(() => this.toggleVisibility(), 550);
      },
      toggleVisibility() {
        if (this.zoomOpen) return;
        const $ATCButton = document.querySelector('.PDPaddToCart .btn--add-to-cart');
        if (!$ATCButton) return;
        if (!this.isStickyAtcViewport()) {
          this.clearStickyAtcState();
          return;
        }
        const rect = $ATCButton.getBoundingClientRect();
        const hasScrolledPastATC = rect.bottom < 0;
        const stickyContainer = document.querySelector('.sticky-atc-container');
        if (stickyContainer) {
          stickyContainer.classList.toggle('opacity-0', !hasScrolledPastATC);
        }
        const templateProduct = document.querySelector('.template-product');
        const stickyHidden = !stickyContainer || stickyContainer.style.display === 'none';
        const shouldShow = Boolean(templateProduct && hasScrolledPastATC && !stickyHidden);
        if (templateProduct) {
          templateProduct.classList.toggle('sticky-atc-container-visible', shouldShow);
        }
        document.documentElement.classList.toggle('sticky-atc-container-visible', shouldShow);
        if (shouldShow) {
          this.updateFloatingWidgetLift(stickyContainer);
        } else {
          document.documentElement.style.removeProperty('--sticky-atc-shift');
        }
        this.stickyVisible = shouldShow;
      },
      handleScroll() {
        this.checkScrollPosition();
        this.toggleVisibility();
        this.updateStickyButtonPosition();
      },
      checkScrollPosition() {
        const stickyContainer = document.querySelector('.sticky-atc-container');
        if (!stickyContainer) return;
        // offsetHeight reads 0 while the bar is display: none - cache it so the
        // threshold stays stable and the bar reappears at the same scroll point
        this.stickyBarHeight = stickyContainer.offsetHeight || this.stickyBarHeight || 0;
        const offset = parseFloat(getComputedStyle(stickyContainer).getPropertyValue('--sticky-atc-offset')) || 0;
        const distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
        // Release only the last bar-height sliver so the bar never permanently
        // covers the subfooter's bottom links at max scroll
        stickyContainer.style.display = distanceFromBottom <= this.stickyBarHeight + offset ? 'none' : 'flex';
      },
      updateStickyButtonPosition() {
        const stickyContainer = document.querySelector('.sticky-atc-container');
        if (!stickyContainer) return;
        const $cookieBanner = document.getElementById('site-cb-footer');
        const isCookieBannerVisible = !!$cookieBanner && document.body.classList.contains('cb-showing') && !$cookieBanner.classList.contains('hidden-bar');
        stickyContainer.style.setProperty('--sticky-atc-offset', isCookieBannerVisible ? '50px' : '0px');
      },
      CBPositionAddToCart() {
        this.updateStickyButtonPosition();
      },
      initializeStickyATC() {
        if (!this.$refs.stickyATCBtn?.$el) return;
        if (!this.isStickyAtcViewport()) {
          this.clearStickyAtcState();
          return;
        }
        if (!this.stickyAtcInitialized) {
          this.CBPositionAddToCart();
          this.stickyAtcInitialized = true;
        }
        this.handleScroll();
      },
      scrollToVariantData() {
        let variantOptionsBlock = document.querySelector('.color-variant-options') || document.querySelector('.size-variant-options') || document.querySelector('.width-variant-options');
        let headerWrapperHeight = document.querySelector('.header__wrapper').clientHeight;
        let distanceFromTop = variantOptionsBlock.getBoundingClientRect().top + window.scrollY - headerWrapperHeight;
        window.scrollTo({
          top: distanceFromTop,
          behavior: 'smooth'
        });
      },
      getVariantData() {
        let swatch = document.querySelector('.image-swatches.selected') || document.querySelector('.color-swatches.selected');
        this.selectedColor = swatch ? (swatch.getAttribute('data-color') === 'Default Title' ? 'OS' : swatch.getAttribute('data-color')) : 'OS';

        let selectedSizeSelector = document.querySelector('.option2.selected');
        this.selectedSize = selectedSizeSelector ? selectedSizeSelector.textContent : null;

        let option3Selector = document.querySelector('.option3.selected');
        this.selectedBling = option3Selector ? option3Selector.textContent : null;

        let variantData = [this.selectedColor, this.selectedSize, this.selectedBling].filter(Boolean).join(' / ');
        return variantData;
      },
      checkComingSoonState(tags) {
        tags.forEach(tag => {
          if (tag === this.comingsoon_tag) {
            this.comingSoonProduct = true;
          }
        });
      },
      checkShouldFormShow() {
        if (this.instock) {
          this.showingForm = false;
        }
        if (this.comingSoonProduct) {
          this.showingForm = false;
        }
      },
      checkIfKlaviyoLoaded() {
        if (window.klaviyo) {
          return true;
        }
      },
      checkKlaviyo() {
        if (this.enable_klaviyo != 'false') {
          if (this.instock || this.notavail || this.comingSoonProduct) {
            this.klaviyoFormShowing = false;
          } else {
            this.klaviyoFormShowing = true;
          }
        }
      },
      checkSoldOutMessage() {
        let message = this.SoldOutText;
        if (this.notavail) {
          message = this.UnavailableText;
        }
        if (!this.hideButton) {
          message = this.NotifyMeText;
          this.showingForm = true;
        }
        return message;
      },
      convertToCurrency(str) {
        let dollarUS = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currencyCode
        });
        let price = dollarUS.format(str).replace('.00', '');
        if (price.includes('CA')) {
          price = price.replace('CA', '');
          price = price + ' CAD';
        }
        return price;
      }
    }
  };
</script>

<template>
  <div v-show="showWidget">
    <div :class="'checkKlaviyo' + checkKlaviyo()"></div>
    <div class="sticky-atc-container opacity-0">
      <button class="sticky-variant-data" @click="scrollToVariantData()" ref="stickyVariantData">
        <span v-html="getVariantData()"></span>
      </button>
      <PDPaddToCartButton ref="stickyATCBtn" :instock="instock" :comingSoonProduct="comingSoonProduct" :success="success" :addToCartText="addToCartText" :comingsoonText="comingsoonText" :variantPrice="variantPrice" :membershipPrice="membershipPrice" :useMemberPrice="useMemberPrice" :soldOutText="SoldOutText" :unavailableText="UnavailableText" :notifyMeText="NotifyMeText" :notavail="notavail" :showingForm="showingForm" :variantId="variantId" :formEmail="formEmail" :loading="loading" :klaviyoFormShowing="klaviyoFormShowing" :klaviyo_key="klaviyo_key" :emailFormValidationError="emailFormValidationError" :isSticky="true" :scrollToVariantData="scrollToVariantData" :formEmailList="formEmailList" :formEmailListId="formEmailListId" />
    </div>
    <p v-html="NotifyMeSuccess" class="successMessage" v-if="success"></p>
  </div>
</template>

<style lang="scss">
  #sticky-PDPaddtocart.is-tablet,
  #sticky-PDPaddtocart.is-desktop {
    display: none;
  }

  #sticky-PDPaddtocart {
    .sticky-atc-container {
      position: fixed;
      bottom: calc(var(--sticky-atc-offset, 0px) + env(safe-area-inset-bottom, 0px));
      left: 0;
      right: 0;
      z-index: var(--z-sticky-atc);
      display: flex;
      overflow: hidden;
      -webkit-backdrop-filter: none;
      backdrop-filter: none;
      pointer-events: auto;
    }

    .btn--outline:hover,
    .btn--outline:focus {
      background: var(--text);
    }
    .btn--add-to-cart {
      flex: 1;
      opacity: 1;
      transition: all 0.5s ease-in-out;
      min-height: 55px;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .sticky-variant-data {
      flex: 1;
      opacity: 1;
      background-color: var(--COLOR-BG);
      padding: var(--space-3) var(--space-5);
      font-family: var(--GT-P);
      border: 1px solid var(--COLOR-BG);
      transition: all 0.5s ease-in-out;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      min-height: 55px;
      line-height: 1.2;
    }
    .opacity-0 {
      opacity: 0;
      z-index: 0;
      pointer-events: none;
    }
  }
</style>
